function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#746b7a;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Domains");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M17.097,15.16606c.12692.281.2442.54165.36229.80193q.54786,1.20746,1.09647,2.41456a.94406.94406,0,0,1-.11,1.05283,1.19411,1.19411,0,0,1-.3423.26707,3.66781,3.66781,0,0,1-.49526.22363.958.958,0,0,1-1.26763-.54528q-.68052-1.505-1.35925-3.01072c-.02287-.05066-.04627-.10109-.07646-.167-.03407.03849-.0614.06779-.087.09853q-.69759.83754-1.39539,1.67489a.49559.49559,0,0,1-.87088-.25535,1.01746,1.01746,0,0,1-.00684-.14661q-.00045-4.1572-.00017-8.31442a.5069.5069,0,0,1,.84759-.441q.7217.61468,1.44457,1.228,2.43043,2.0656,4.86083,4.13127a.73.73,0,0,1,.2782.33113.49921.49921,0,0,1-.50743.65591c-.74624.00227-1.49248.00069-2.23872.0007Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M11.5926,12.44424H6.36945A25.05151,25.05151,0,0,1,6.36831,6.715h6.35188l.09231,1.00241a3.72615,3.72615,0,0,0-.46429.18859,1.41637,1.41637,0,0,0-.75445,1.30044c-.00408,1.03565-.00116,2.07133-.00116,3.107Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M4.93158,6.71318a25.736,25.736,0,0,0,.00053,5.73108c-.04077.00225-.077.006-.11318.006q-2.13882.00043-4.27765.002c-.07864.00014-.11537-.01932-.13843-.09913a9.74315,9.74315,0,0,1,.0072-5.56174.09781.09781,0,0,1,.11434-.08493q2.15975.00236,4.3195.00142C4.87121,6.7079,4.89854,6.71111,4.93158,6.71318Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M12.49948,5.26284H6.59281a18.719,18.719,0,0,1,.51554-2.02531,9.51278,9.51278,0,0,1,.86574-1.96246A3.24848,3.24848,0,0,1,8.86438.24327a1.09031,1.09031,0,0,1,1.441.05994,3.60861,3.60861,0,0,1,.795.9525,10.41612,10.41612,0,0,1,1.09469,2.72483C12.30794,4.401,12.397,4.82786,12.49948,5.26284Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M11.5926,13.89544v.396c0,.85037.00083,1.78-.00175,2.63032a5.67473,5.67473,0,0,1-.806,1.43229,3.35771,3.35771,0,0,1-.54137.53507A1.07253,1.07253,0,0,1,8.781,18.855a3.511,3.511,0,0,1-.79918-.96255,10.89135,10.89135,0,0,1-1.18044-3.07067c-.07336-.3052-.14031-.612-.2121-.92635Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M18.7407,12.1073c-.3841-.32608-.7592-.64442-1.1342-.96288q-1.61671-1.373-3.23418-2.74513a.23307.23307,0,0,1-.09452-.17437c-.03552-.50212-.07583-1.0039-.11545-1.51724h4.49659a10.32019,10.32019,0,0,1,.40355,3.55333,9.51889,9.51889,0,0,1-.299,1.79687A.38736.38736,0,0,1,18.7407,12.1073Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M6.79376.41463A14.41477,14.41477,0,0,0,5.13614,5.26327H1.01826A9.52946,9.52946,0,0,1,6.79376.41463Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M18.06384,5.26418H13.94678A14.00642,14.00642,0,0,0,12.26905.40166,9.41814,9.41814,0,0,1,15.67064,2.2362,9.59018,9.59018,0,0,1,18.06384,5.26418Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M6.81146,18.74629a9.46665,9.46665,0,0,1-5.77735-4.852H5.13677A14.04585,14.04585,0,0,0,6.81146,18.74629Z"
});

var SvgDomains = function SvgDomains(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDomains, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/domains.ee407097.svg";
export { ForwardRef as ReactComponent };